import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'react-jss';

import { Layout } from '../../components/Layout';
import { Background } from '../../components/Background';
import { App } from '../../components/App';
import { Popup } from '../../components/Popup';
import { MusicPlayer } from '../../components/MusicPlayer';
import themeBlack from '../../settings/theme';

class Component extends React.Component {
  static displayName = 'Template';

  static propTypes = {
    location: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    layout: PropTypes.object,
    background: PropTypes.object,
    children: PropTypes.any
  };

  static defaultProps = {
    layout: {},
    background: {}
  };

  constructor () {
    super(...arguments);

    this.state = {
      show: false,
      enterShow: false,
      enterAnimationShow: true
    };
  }

  componentDidMount () {
    const { theme } = this.props;

    if (typeof document !== 'undefined' && document.body) {
      document.body.style.backgroundColor = themeBlack.color.background.dark;
    }

    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.removeItem('site_entered');
      }
    } catch (e) {}

    setTimeout(
      () => this.setState({ enterShow: true }),
      theme.animation.time
    );
  }

  onEnter = () => {
    const { theme } = this.props;

    try {
      if (typeof window !== 'undefined') {
        if (window.localStorage) {
          window.localStorage.removeItem('site_entered');
        }
        if (window.Howler && window.Howler.ctx && window.Howler.ctx.state === 'suspended') {
          window.Howler.ctx.resume().catch(() => {});
        }
        if (window.__siteAudioCtx && window.__siteAudioCtx.state === 'suspended') {
          window.__siteAudioCtx.resume().catch(() => {});
        }
      }
    } catch (e) {}

    this.setState({ enterAnimationShow: false });

    setTimeout(
      () => this.setState({ show: true }),
      theme.animation.time + theme.animation.stagger
    );
  }

  render () {
    const { show, enterShow, enterAnimationShow } = this.state;
    const { location, classes, layout, background, children } = this.props;

    const currentTheme = themeBlack;

    const isURLContent = ['/certificates', '/projects', '/about', '/resume', '/sertifikalarim', '/blog', '/projelerim', '/hakkimda'].find(path => {
      return location.pathname.indexOf(path) === 0;
    });

    return (
      <ThemeProvider theme={currentTheme}>
        <Layout {...layout}>
          <Background
            {...background}
            theme={currentTheme}
            animation={{ show, ...background.animation }}
          >
            {isURLContent ? <App>{children}</App> : children}
            <MusicPlayer theme={currentTheme} />

            {!show && (
              <div className={classes.enterOverlay}>
                {enterShow && (
                  <Popup
                    className={classes.enterElement}
                    ref={ref => (this.enterElement = ref)}
                    audio={{ silent: true }}
                    animation={{ independent: true, show: enterAnimationShow }}
                    message='melihemik.com.tr will use sound.'
                    option='OK'
                    onOption={this.onEnter}
                  />
                )}
              </div>
            )}
          </Background>
        </Layout>
      </ThemeProvider>
    );
  }
}

export { Component };

// Commit trace: 2025-07-05T14:39:17 - fix: resolve minor issue in Template.js

// Commit trace: 2025-10-19T10:26:39 - perf: improve memory usage in Template.js

// Commit trace: 2026-02-12T04:44:06 - fix: resolve minor issue in Template.js
